import { Component, OnInit, Input } from "@angular/core";
import { CTAButtonLayout } from "../cta-button-layout";
import { CTAButtonLayoutImagesTitleContext } from "./cta-button-layout-images-title.models";

@Component({
    selector: "dodo-cta-button-layout-images-title",
    templateUrl: "./cta-button-layout-images-title.component.html",
    styleUrls: ["./cta-button-layout-images-title.component.scss"],
    standalone: false
})
export class CtaButtonLayoutImagesTitleComponent extends CTAButtonLayout
	implements OnInit {
	@Input() images: string[];
	@Input() title: string;
	@Input() imageSize: number;

	@Input() set context(ctx: CTAButtonLayoutImagesTitleContext) {
		if (ctx) {
			this.images = this.images || ctx.images;
			this.title = this.title || ctx.title;
		}
	}

	set layoutContext(ctx: CTAButtonLayoutImagesTitleContext) {
		if (ctx) {
			this.images = this.images || ctx.images;
			this.title = this.title || ctx.title;
		}
	}

	constructor() {
		super();
	}

	ngOnInit() {}
}
